<template>
    <div>
        <editor
            v-if="mounted"
            v-model="content"
            :api-key="event.tinyMceApiKey"
            :init="{
                min_height: 200,
                menubar: false,
                branding: false,
                contextmenu:false,
                paste_data_images: true,
                images_upload_handler: (blobInfo, success, failure) => {
                    success('data:' + blobInfo.blob().type + ';base64,' + blobInfo.base64());
                },
                plugins: [
                'advlist autolink lists image charmap print preview anchor',
                'searchreplace code fullscreen autoresize',
                'insertdatetime media table code wordcount image'
                ],
                toolbar:
                'undo redo | formatselect | bold italic backcolor blockquote subscript superscript underline | \
                alignleft aligncenter alignright alignjustify | \
                bullist numlist outdent indent | removeformat | table | image media | fullscreen searchreplace code'
            }"
        />
        <div v-else style="display: flex; justify-content: center; align-items: center; flex-direction: column;">
            <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a">
                        <stop stop-color="#000" stop-opacity="0" offset="0%"/>
                        <stop stop-color="#000" stop-opacity=".631" offset="63.146%"/>
                        <stop stop-color="#000" offset="100%"/>
                    </linearGradient>
                </defs>
                <g fill="none" fill-rule="evenodd">
                    <g transform="translate(1 1)">
                        <path d="M36 18c0-9.94-8.06-18-18-18" id="Oval-2" stroke="url(#a)" stroke-width="2">
                            <animateTransform
                                attributeName="transform"
                                type="rotate"
                                from="0 18 18"
                                to="360 18 18"
                                dur="0.9s"
                                repeatCount="indefinite" />
                        </path>
                        <circle fill="#000" cx="36" cy="18" r="1">
                            <animateTransform
                                attributeName="transform"
                                type="rotate"
                                from="0 18 18"
                                to="360 18 18"
                                dur="0.9s"
                                repeatCount="indefinite" />
                        </circle>
                    </g>
                </g>
            </svg>
            <span style="font-size: 12px;">Editor loading ...</span>
        </div>

    </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import { mapState } from 'vuex';

export default{
    props:{
        value: String
    },
    components: {
        Editor
    },
    computed:{
        ...mapState(["event"])
    },
    watch:{
        value(){
            this.content = this.value
        },
        content(nv){
            this.$emit('input', nv)
        }
    },
    data(){
        return{
            content: "",
            mounted: false
        }
    },
    mounted(){
        this.content = this.value
        this.mounted = true
        console.log("Editor mounted");
    }

}
</script>

<style>
.tox-tinymce-aux{z-index:99999999999 !important;}
.tox-notifications-container{ display: none !important; }
</style>